const sellCarForm = [
  {
    name: "name",
    label: "Name",
    type: "text",
    placeholder: "Enter your full name",
    is_show: true,
    required: true,
    layout: "half",
  },
  {
    name: "phone",
    label: "Phone Number",
    type: "tel",
    placeholder: "Enter phone number",
    is_show: true,
    required: true,
    layout: "half",
  },
  {
    name: "brand",
    label: "Brand",
    type: "select",
    placeholder: "Select Brand",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "brands",
  },
  {
    name: "model",
    label: "Model",
    type: "select",
    placeholder: "Select Model",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "model",
    dependsOn: {
      field: "brand",
      parentSource: "brands",
      filterKey: "brand_id",
      waitMessageKey: "selectBrandFirst",
    },
  },
  {
    name: "body_type",
    label: "Body Type",
    type: "select",
    placeholder: "Select Body Type",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "body_type",
  },
  {
    name: "fuel",
    label: "Fuel Type",
    type: "select",
    placeholder: "Select Fuel Type",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "fuel_type",
  },
  {
    name: "transmission",
    label: "Transmission",
    type: "select",
    placeholder: "Select Transmission",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "transmission",
  },
  {
    name: "color",
    label: "Color",
    type: "select",
    placeholder: "Select Color",
    is_show: true,
    required: false,
    layout: "half",
    optionsSource: "car_color",
  },
  {
    name: "seats",
    label: "Seats",
    type: "select",
    placeholder: "Select Seats",
    is_show: true,
    required: false,
    layout: "half",
    optionsSource: "seats",
  },
  {
    name: "state",
    label: "State",
    type: "select",
    placeholder: "Select State",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "state",
  },
  {
    name: "city",
    label: "City",
    type: "select",
    placeholder: "Select City",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "city",
    dependsOn: {
      field: "state",
      parentSource: "state",
      filterKey: "state_id",
      waitMessageKey: "selectStateFirst",
    },
  },
  {
    name: "sub_register",
    label: "Sub Register",
    type: "select",
    placeholder: "Select Sub Register",
    is_show: true,
    required: false,
    layout: "half",
    optionsSource: "sub_register",
    dependsOn: {
      field: "city",
      parentSource: "city",
      filterKey: "city_id",
      waitMessageKey: "selectCityFirst",
    },
  },
  {
    name: "year",
    label: "Manufacturing Year",
    type: "number",
    placeholder: "Enter manufacturing year",
    is_show: true,
    required: true,
    layout: "half",
    min: 1990,
    max: 2030,
    step: 1,
  },
  {
    name: "km_driven",
    label: "KM Driven",
    type: "number",
    placeholder: "Enter total kilometres driven",
    is_show: true,
    required: true,
    layout: "half",
    min: 0,
    max: 9999999,
    step: 1,
    hint: "Total distance the car has been driven in kilometres",
  },
  {
    name: "tire_wear",
    label: "Tyre Condition",
    type: "select",
    placeholder: "Select Tyre Condition",
    is_show: true,
    required: true,
    layout: "half",
    hint: "Estimate overall tyre wear based on current condition",
    options: [
      { value: "5", label: "Excellent (Like New)" },
      { value: "15", label: "Good (Minimal Wear)" },
      { value: "30", label: "Fair (Moderate Wear)" },
      { value: "50", label: "Needs Replacement Soon" },
      { value: "75", label: "Poor (Heavy Wear)" },
    ],
  },
  {
    name: "price",
    label: "Expected Price",
    type: "number",
    placeholder: "Enter expected price",
    is_show: true,
    required: true,
    layout: "half",
    min: 0,
    step: 1,
    hint: "Enter your expected selling price in INR",
  },
  {
    name: "youtube",
    label: "YouTube Video URL",
    type: "url",
    placeholder: "https://www.youtube.com/embed/...",
    is_show: true,
    required: false,
    layout: "full",
  },
  {
    name: "youtube_shorts",
    label: "YouTube Shorts URL",
    type: "url",
    placeholder: "https://youtube.com/shorts/... or embed/watch link",
    is_show: true,
    required: false,
    layout: "full",
  },
];

export default sellCarForm;
